module.exports = __webpack_public_path__ + "img/1440.70a831b8.svg";